module.exports = __webpack_public_path__ + "static/media/icons-children.160fdd23.svg";